export default __webpack_public_path__ + "static/Swiss721BT-Roman-37c09eb6b81468c79307ad1572537fb8.woff";